// Helpers de formatação, parsing e ícones SVG.
// Extraídos do main.js legado, mantendo o MESMO comportamento.

// Converte texto/valor em número (aceita vírgula decimal). Vazio/inválido → null.
export const num = v => {
  if (v === '' || v == null) return null
  const n = parseFloat(String(v).replace(',', '.'))
  return isNaN(n) ? null : n
}

// Formata número como moeda BR (sem o símbolo "R$"). Null → travessão.
export const brl = n =>
  n == null
    ? '—'
    : n.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

// Escapa HTML para uso seguro em innerHTML.
export const esc = s =>
  String(s == null ? '' : s)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')

// Data de hoje no formato dd/mm/aaaa (string exibida nas tabelas).
export const hojeBR = () => {
  const d = new Date()
  return (
    String(d.getDate()).padStart(2, '0') +
    '/' +
    String(d.getMonth() + 1).padStart(2, '0') +
    '/' +
    d.getFullYear()
  )
}

// Faz o parse de uma data dd/mm/aaaa (ou dd/mm/aa) em objeto Date. Inválido → null.
export const parseBR = s => {
  if (!s) return null
  const m = String(s).trim().match(/^(\d{1,2})\/(\d{1,2})\/(\d{2,4})$/)
  if (!m) return null
  let y = +m[3]
  if (y < 100) y += 2000
  const d = new Date(y, +m[2] - 1, +m[1])
  return isNaN(d) ? null : d
}

// Máscara de data: mantém só dígitos e insere as barras de dd/mm/aaaa
// automaticamente (no máx. 8 dígitos). Letras e caracteres inválidos são
// descartados, então o campo nunca aceita texto que vira null ao salvar.
export const maskBRDate = v => {
  const d = String(v ?? '').replace(/\D/g, '').slice(0, 8)
  if (d.length <= 2) return d
  if (d.length <= 4) return d.slice(0, 2) + '/' + d.slice(2)
  return d.slice(0, 2) + '/' + d.slice(2, 4) + '/' + d.slice(4)
}

// Valida se a string é uma data dd/mm/aaaa REAL (mês 1-12, dia válido p/ o mês).
export const isValidBRDate = s => {
  const m = String(s ?? '').trim().match(/^(\d{2})\/(\d{2})\/(\d{4})$/)
  if (!m) return false
  const d = +m[1], mo = +m[2], y = +m[3]
  if (mo < 1 || mo > 12 || d < 1 || y < 1900 || y > 2999) return false
  return d <= new Date(y, mo, 0).getDate() // último dia do mês
}

// Estado de um campo de data mascarado, para decidir salvar e marcar inválido:
//   vazio              -> salva (limpa)
//   completa e válida  -> salva
//   completa e inválida-> NÃO salva, marca vermelho
//   incompleta         -> NÃO salva, sem marcar (ainda digitando)
export const dateFieldState = v => {
  const s = String(v ?? '')
  if (s === '') return { salvar: true, invalida: false }
  const completa = /^\d{2}\/\d{2}\/\d{4}$/.test(s)
  if (completa && isValidBRDate(s)) return { salvar: true, invalida: false }
  return { salvar: false, invalida: completa }
}

// Quantidade de dias decorridos desde a data informada (dd/mm/aaaa).
export const daysSince = s => {
  const d = parseBR(s)
  if (!d) return null
  return Math.floor((Date.now() - d.getTime()) / 86400000)
}

// Ícones SVG inline reaproveitados em várias áreas.
export const svgDel =
  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 7h16M9 7V4h6v3m1 0v13a1 1 0 01-1 1H8a1 1 0 01-1-1V7"/></svg>'
export const svgCopy =
  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="9" y="9" width="11" height="11" rx="2"/><path d="M5 15V5a2 2 0 012-2h10"/></svg>'
